import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material";
import PropTypes from "prop-types";
import {
  LocalizationProvider,
  MobileDatePicker,
  CalendarIcon,
} from "@mui/x-date-pickers";

const DatePicker = ({
  shouldDisableDate,
  disableFuture,
  onMonthChange,
  onYearChange,
  disablePast,
  disabled,
  onChange,
  onAccept,
  maxDate,
  onClose,
  value,
  open,
}) => {
  const theme = createTheme({
    typography: {
      fontFamily: "Lato",
      body1: {
        color: "#60656D",
      },
    },
  });

  return (
    <div className="flex flex-row">
      <div className="flex flex-col w-full">
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              open={open}
              onClose={onClose}
              disabled={disabled}
              disablePast={disablePast}
              format="LL"
              slotProps={{
                textField: {
                  InputProps: {
                    size: "small",
                    startAdornment: (
                      <CalendarIcon className="mr-2 text-[#A3A7AB]" />
                    ),
                  },
                  placeholder: "Select a date",
                },
                dialog: {
                  onClose: (e, reason) => {
                    if (reason === "backdropClick") {
                      return;
                    }
                  },
                },
              }}
              value={value}
              onChange={onChange}
              onAccept={onAccept}
              maxDate={maxDate}
              disableFuture={disableFuture}
              onMonthChange={onMonthChange}
              onYearChange={onYearChange}
              shouldDisableDate={shouldDisableDate}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </div>
    </div>
  );
};

DatePicker.propTypes = {
  shouldDisableDate: PropTypes.func,
  disableFuture: PropTypes.bool,
  onMonthChange: PropTypes.func,
  onYearChange: PropTypes.func,
  disablePast: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  maxDate: PropTypes.any,
  value: PropTypes.any,
  open: PropTypes.bool,
};

export default DatePicker;
